import { ReactNode, useEffect, useState } from "react";

/**
 * Renders its children once the previous page has cleared `filtersAtom`.
 *
 * Pages sharing the atom (dashboard, events…) clear it in an effect cleanup,
 * which React runs after the next page's first render: without this gate that
 * render, and the effects it starts (URL sync, filter chips), would use the
 * previous page's filters. Unmount cleanups all run before mount effects, so
 * the atom is clean by the time this one flips.
 */
const FreshFilters = ({ children }: { children: ReactNode }) => {
  const [ready, setReady] = useState(false);
  useEffect(() => setReady(true), []);
  return ready ? <>{children}</> : null;
};

export default FreshFilters;
